// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__20h8I","Logo":"Toolbar_Logo__2tT_7","DesktopOnly":"Toolbar_DesktopOnly__3Q3Ml"};